// // import React from 'react';
// // import { useQuery, useMutation, useQueryClient } from 'react-query';
// // import { getCategories, deleteCategory } from '../../../api/category';
// // import { Link } from 'react-router-dom';
// // import { toast } from 'react-toastify';

// // const CategoryList = () => {
// //   const queryClient = useQueryClient();
// //   const { data: categories, error, isLoading } = useQuery('categories', getCategories);

// //   const deleteMutation = useMutation(deleteCategory, {
// //     onSuccess: () => {
// //       queryClient.invalidateQueries('categories');
// //       toast.success('Category deleted successfully');
// //     },
// //     onError: () => {
// //       toast.error('Failed to delete category');
// //     }
// //   });

// //   if (isLoading) return <div>Loading...</div>;
// //   if (error) return <div>Error: {error.message}</div>;

// //   return (
// //     <div>
// //       <h1>Categories</h1>
// //       <Link to="/dashboard/categories/new">Add New Category</Link>
// //       <ul>
// //         {categories.map(category => (
// //           <li key={category._id}>
// //             {category.name}
// //             <button onClick={() => deleteMutation.mutate(category._id)}>Delete</button>
// //             <Link to={`/dashboard/categories/${category._id}/edit`}>Edit</Link>
// //           </li>
// //         ))}
// //       </ul>
// //     </div>
// //   );
// // };

// // export default CategoryList;



// import React, { useState } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import { Link, useNavigate } from 'react-router-dom';
// import {
//   Box,
//   Button,
//   Heading,
//   Spinner,
//   Text,
//   useToast,
//   VStack,
//   HStack,
//   IconButton,
//   AlertDialog,
//   AlertDialogOverlay,
//   AlertDialogContent,
//   AlertDialogHeader,
//   AlertDialogBody,
//   AlertDialogFooter,
//   useDisclosure,
//   Flex,
// } from '@chakra-ui/react';
// import { FaTrash, FaEdit } from 'react-icons/fa';
// import { getCategories, deleteCategory } from '../../../api/category';

// const CategoryList = () => {
//   const queryClient = useQueryClient();
//   const { data: categories, error, isLoading } = useQuery('categories', getCategories);
//   const toast = useToast();
//   const navigate = useNavigate();

//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const [deleteId, setDeleteId] = useState(null);

//   const deleteMutation = useMutation(deleteCategory, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('categories');
//       toast({
//         title: 'Category deleted.',
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//       onClose();
//     },
//     onError: () => {
//       toast({
//         title: 'Failed to delete category.',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//       onClose();
//     },
//   });

//   const handleDelete = (id) => {
//     setDeleteId(id);
//     onOpen();
//   };

//   const confirmDelete = () => {
//     if (deleteId) {
//       deleteMutation.mutate(deleteId);
//     }
//   };

//   if (isLoading) {
//     return (
//       <Flex justify="center" align="center" h="100vh">
//         <Spinner size="xl" />
//       </Flex>
//     );
//   }

//   if (error) {
//     return <Text color="red.500">Error: {error.message}</Text>;
//   }

//   return (
//     <Box p={5}>
//       <Flex justify="space-between" align="center" mb={5}>
//         <Heading>Categories</Heading>
//         <Button colorScheme="blue" as={Link} to="/dashboard/admin/categories/New">
//           Add New Category
//         </Button>
//       </Flex>
//       <VStack spacing={4} align="stretch">
//         {categories?.data?.data?.map((category) => (
//           <HStack key={category._id} justify="space-between" w="100%" p={4} borderWidth="1px" borderRadius="md">
//             <Text fontSize="lg">{category.name}</Text>
//             <HStack spacing={2}>
//               <IconButton
//                 icon={<FaEdit />}
//                 colorScheme="teal"
//                 aria-label="Edit"
//                 onClick={() => navigate(`/dashboard/admin/categories/${category._id}/edit`)}
//               />
//               <IconButton
//                 icon={<FaTrash />}
//                 colorScheme="red"
//                 aria-label="Delete"
//                 onClick={() => handleDelete(category._id)}
//               />
//             </HStack>
//           </HStack>
//         ))}
//       </VStack>
//       <AlertDialog
//         isOpen={isOpen}
//         leastDestructiveRef={undefined}
//         onClose={onClose}
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader fontSize="lg" fontWeight="bold">
//               Delete Category
//             </AlertDialogHeader>
//             <AlertDialogBody>
//               Are you sure you want to delete this category? This action cannot be undone.
//             </AlertDialogBody>
//             <AlertDialogFooter>
//               <Button onClick={onClose}>
//                 Cancel
//               </Button>
//               <Button colorScheme="red" onClick={confirmDelete} ml={3} isLoading={deleteMutation.isLoading}>
//                 Delete
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>
//     </Box>
//   );
// };

// export default CategoryList;













// import React, { useState } from 'react';
// import { useCategories, useDeleteCategory } from '../../../hooks/useCategories';
// import {
//   Box,
//   Button,
//   Table,
//   Tbody,
//   Td,
//   Th,
//   Thead,
//   Tr,
//   Spinner,
//   Input,
//   Select,
// } from '@chakra-ui/react';
// import { AddIcon } from '@chakra-ui/icons';
// import { useNavigate } from 'react-router-dom';

// const CategoryList = () => {
//   const [params, setParams] = useState({ page: 1, limit: 1,name: '', createdAt: '' });
//   const { data, error, isLoading } = useCategories(params);
//   const deleteCategory = useDeleteCategory();
//   const history = useNavigate();
// console.log(data)
//   const handleDelete = (id) => {
//     deleteCategory.mutate(id);
//   };

//   const handleSearch = (e) => {
//     setParams({ ...params, search: e.target.value, page: 1 });
//   };

//   const handleFilter = (e) => {
//     setParams({ ...params, createdAt: e.target.value, page: 1 });
//   };

//   const handlePageChange = (newPage) => {
//     setParams({ ...params, page: newPage });
//   };

//   if (isLoading) return <Spinner />;
//   if (error) return <div>Error fetching categories</div>;

//   return (
//     <Box>
//       <Box display="flex" justifyContent="space-between" mb="4">
//         <Button leftIcon={<AddIcon />} colorScheme="teal" onClick={() => history.push('/categories/new')}>
//           Add Category
//         </Button>
//         <Box display="flex" gap="2">
//           <Input
//             placeholder="Search..."
//             value={params.search}
//             onChange={handleSearch}
//           />
//           <Select
//             placeholder="Filter by date"
//             value={params.createdAt}
//             onChange={handleFilter}
//           >
//             <option value="desc">Newest</option>
//             <option value="asc">Oldest</option>
//           </Select>
//         </Box>
//       </Box>
//       <Table>
//         <Thead>
//           <Tr>
//             <Th>Name</Th>
//             <Th>Cover</Th>
//             <Th>Subcategory Count</Th>
//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {data?.data?.data?.map((category) => (
//             <Tr key={category._id}>
//               <Td>{category.name}</Td>
//               <Td>{category.cover.name}</Td>
//               <Td>{category.subcategoryCount}</Td>
//               <Td>
//                 <Button
//                   size="sm"
//                   onClick={() => history(`/categories/${category._id}`)}
//                 >
//                   View
//                 </Button>
//                 <Button
//                   size="sm"
//                   onClick={() => history(`/categories/edit/${category._id}`)}
//                 >
//                   Update
//                 </Button>
//                 <Button
//                   size="sm"
//                   colorScheme="red"
//                   onClick={() => handleDelete(category._id)}
//                 >
//                   Delete
//                 </Button>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>
//       <Box mt="4" display="flex" justifyContent="space-between">
//         <Button
//           onClick={() => handlePageChange(params.page - 1)}
//           disabled={params.page === 1}
//         >
//           Previous
//         </Button>
//         <Button
//           onClick={() => handlePageChange(params.page + 1)}
//           disabled={!data.hasMore}
//         >
//           Next
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default CategoryList;


import React, { useState, useEffect } from 'react';
import { useCategories, useDeleteCategory } from '../../../hooks/useCategories';
import {
  Box,
  Button,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Spinner,
  Input,
  Select,
  Toast,
  useToast

} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
const limit = 50;
const CategoryList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [params, setParams] = useState({ page: 1 ,limit,sort: ''});

  useEffect(() => {
    const queryParams = queryString.parse(location.search);
    setParams({
      ...params,
      ...queryParams,
      page: queryParams.page ? Number(queryParams.page) : 1,
     
    });
  }, [location.search]);

  const { data, error, isLoading } = useCategories(params);

  const deleteCategory = useDeleteCategory();

  const updateURL = (newParams) => {
    const search = queryString.stringify(newParams);
    navigate(`?${search}`);
  };
const toast= useToast()
  const handleDelete = (id) => {
    deleteCategory.mutate(id, {
      onSuccess: () => {
   toast({
          title: 'Category deleted successfully',
          status: 'success',
          duration: 5000,
          isClosable: true,
        })
    
   
        updateURL({ ...params });
      },
    });
  };

  const handleSearch = (e) => {
    setParams((prevParams) => ({ ...prevParams, name: e.target.value }));
  };

  const handleFilter = (e) => {
    const newParams = { ...params, sort: e.target.value };

    setParams(newParams);
    updateURL(newParams);

  };

  const handlePageChange = (newPage) => {
    const newParams = { ...params, page: newPage };
    setParams(newParams);
    updateURL(newParams);
  };

  const handleSearchClick = () => {
    const newParams = { ...params, page: 1 };
    setParams(newParams);
    updateURL(newParams);
  };

  if (isLoading) return <Spinner />;
  if (error) return <div>Error fetching categories</div>;

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" mb="4">
        <Button leftIcon={<AddIcon />} colorScheme="teal" onClick={() => navigate('/dashboard/admin/categories/New')}>
          Add Category
        </Button>
        <Box display="flex" gap="2">
          {/* <Input
            placeholder="Search..."
            value={params.name}
            onChange={handleSearch}
          />
          <Button onClick={handleSearchClick} colorScheme="blue">
            Search
          </Button> */}
          <Select
            placeholder="Sort by date"
            value={params.sort}
            onChange={handleFilter}
          >
            <option value="createdAt">Oldest</option>
            <option value="-createdAt">Newest</option>
            <option value="name">name asc</option>
            <option value="-name">name des</option>
          </Select>
        </Box>
      </Box>
      <Box>total categories: {data?.counts}</Box>
      <Table>
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Cover</Th>
            {/* <Th>Subcategory Count</Th> */}
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.data?.data?.map((category) => (
            <Tr key={category._id}>
              <Td>{category.name}</Td>
              <Td>{category.cover.name}</Td>
              {/* <Td>{category.subcategoryCount}</Td> */}
              <Td>
                <Button
                  size="sm"
                  onClick={() => navigate(`/dashboard/admin/categories/${category._id}`)}
                >
    View Details                </Button>
                <Button
                  size="sm"
                  onClick={() => navigate(`/dashboard/admin/categories/${category._id}/edit`)}
                >
                  Update
                </Button>
                <Button
                  size="sm"
                  colorScheme="red"
                  onClick={() => handleDelete(category._id)}
                >
                  Delete
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Box mt="4" display="flex" justifyContent="space-between">
        <Button
          onClick={() => handlePageChange(params.page - 1)}
          disabled={params.page === 1}
        >
          Previous
        </Button>
        <Button
          onClick={() => handlePageChange(params.page + 1)}
          disabled={!data?.hasMore}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default CategoryList;
